import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Index from '@/components/Index'
import Login from '@/components/Login'
import HotelList from '@/components/hotel/List' //酒店列表
import HotelTemp from '@/components/hotel/hotelTemp' //酒店详情中转页
import HotelDetails from '@/components/hotel/Details' //酒店详情
import HotelBook from '@/components/hotel/book' //订单填写
import BookComfirm from '@/components/hotel/bookComfirm' //酒店下单
import BookComplete from '@/components/hotel/bookComplete' //酒店下单完成
import RegimentHotel from '@/components/regimentRoom/hotelList' //团购酒店
import RegimentRoom from '@/components/regimentRoom/index' //团购
import RegimentRoomList from '@/components/regimentRoom/List' //团购订单列表
import OrderList from '@/components/order/List' //订单查询
import MyOrderList from '@/components/order/MyList' //订单查询
import OrderDetails from '@/components/order/Details' //订单详情
import OrderCustomer from '@/components/order/Customer' //入住人订单
import Customer from '@/components/order/Customer1' //入住人订单(无权限)
import BillList from '@/components/bill/List' //账单查询
import BillDetails from '@/components/bill/Details' //账单详情
import ReportDay from '@/components/report/ReportDay' //日报表
import ReportList from '@/components/report/List' //报表列表
import ReportMonth from '@/components/report/ReportMonth' //月报表
import Invoice from '@/components/invoice/invoice' //发票
import Information from '@/components/invoice/information' //发票信息
import InvoiceDetails from '@/components/invoice/details' //发票详情
import Hotel from '@/components/invoice/hotel' //酒店发票
import RealTimeSelectionList from '@/components/realTimeSelection/List' //实时精选
import SubAccount from '@/components/account/SubAccount' //子账号管理
import BaseInfo from '@/components/account/BaseInfo' //基础信息
import ReceiptsBill from '@/components/bill/ReceiptsBill' //信贷详情
import ReceiptsBillNew from '@/components/bill/ReceiptsBillNew' //信贷详情新
import ChargeBill from '@/components/bill/ChargeBill' //充值详情
import ResetPassword from '@/components/account/ResetPassword' //修改密码
import About from '@/components/info/about' //关于我们
import Contact from '@/components/info/contact' //联系我们
import Introduction from '@/components/info/introduction' //预订须知
import Cooperation from '@/components/info/cooperation' //合作加盟
import Join from '@/components/info/join' //诚聘英才
import Register from '@/components/info/register' //我要注册
import Tickets from '@/components/ticket/tickets' //门票
import TicketList from '@/components/ticket/list' //门票列表
import TicketDetails from '@/components/ticket/Details' //门票详情
import TicketBook from '@/components/ticket/book/book' //门票下单
import TicketBookComfirm from '@/components/ticket/book/bookComfirm' //门票确认
import TicketBookComplete from '@/components/ticket/book/bookComplete' //门票完成
import PackageList from '@/components/package/list' //度假列表
import PackageDetails from '@/components/package/details' //度假详情
import PackageBook from '@/components/package/book' //度假下单
import PackageBookComfirm from '@/components/package/bookComfirm' //度假支付详情
import PackageBookComplete from '@/components/package/bookComplete' //度假支付结果
import PackageOrderList from '@/components/package/orderList' //度假订单列表
import PackageOrderDetails from '@/components/package/orderDetails' //度假订单详情
import PackageReserve from '@/components/package/reserve/book' //预约详情
import ReserveDetails from '@/components/package/reserve/details' //预约订单详情


import HomeStay from '@/components/homestay/index' //民宿首页

Vue.use(Router)

export default new Router({
    routes: [{
            path: '/',
            name: 'Index',
            component: Index,
            meta: {
                keepAlive: true,
                parentMenu: 'Index'
            }
        },
        {
            path: '/login',
            name: 'Login',
            component: Login,
            meta: {
                isHome: true
            }
        },
        //预订须知
        {
            path: '/introduction',
            name: 'introduction',
            component: Introduction,
            meta: {
                isHome: true
            }
        },
        //加盟合作
        {
            path: '/cooperation',
            name: 'cooperation',
            component: Cooperation,
            meta: {
                isHome: true
            }
        },
        //联系我们
        {
            path: '/contact',
            name: 'contact',
            component: Contact,
            meta: {
                isHome: true
            }
        },
        //关于我们
        {
            path: '/about',
            name: 'about',
            component: About,
            meta: {
                isHome: true
            }
        },
        //诚聘英才
        {
            path: '/join',
            name: 'join',
            component: Join,
            meta: {
                isHome: true
            }
        },
        //我要注册
        {
            path: '/register',
            name: 'register',
            component: Register,
            meta: {
                isHome: true
            }
        },
        //酒店详情中转页
        {
            path: '/hotelTemp',
            name: 'hotelTemp',
            component: HotelTemp,
            meta: {
                parentMenu: 'Index'
            }
        },
        //酒店列表
        {
            path: '/hotelList',
            name: 'HotelList',
            component: HotelList,
            meta: {
                parentMenu: 'auto'
            }
        },
        //酒店详情
        {
            path: '/hotelDetails',
            name: 'HotelDetails',
            component: HotelDetails,
            meta: {
                parentMenu: 'Index'
            }
        },
        //订单填写
        {
            path: '/hotelBook',
            name: 'HotelBook',
            component: HotelBook,
            meta: {
                parentMenu: 'Index'
            }
        },
        //酒店下单
        {
            path: '/bookComfirm',
            name: 'BookComfirm',
            component: BookComfirm,
            meta: {
                parentMenu: 'Index'
            }
        },
        //酒店下单完成
        {
            path: '/bookComplete',
            name: 'BookComplete',
            component: BookComplete,
            meta: {
                parentMenu: 'Index'
            }
        },
        //订单查询
        {
            path: '/orderList',
            name: 'OrderList',
            meta: {
                parentMenu: 'OrderList'
            },
            component: OrderList
        },
        //订单查询
        {
            path: '/myOrderList',
            name: 'MyOrderList',
            component: MyOrderList,
            meta: {
                parentMenu: 'OrderList'
            },
        },
        //订单详情
        {
            path: '/orderDetails/:orderNO',
            name: 'OrderDetails',
            component: OrderDetails,
            meta: {
                isHome: true
            }
        },
        //客人入住
        {
            path: '/orderCustomer/:orderNO',
            name: 'OrderCustomer',
            component: OrderCustomer,
            meta: {
                isHome: true
            }
        },
        //客人入住(无权限)
        {
            path: '/Customer/:orderNO',
            name: 'Customer',
            component: Customer,
            meta: {
                isHome: true,
                skipGlobalInit: true
            }
        },
        //团购酒店
        {
            path: '/regimentHotel',
            name: 'RegimentHotel',
            meta: {
                parentMenu: 'RegimentRoom'
            },
            component: RegimentHotel
        },
        //团购
        {
            path: '/regimentRoom',
            name: 'RegimentRoom',
            meta: {
                parentMenu: 'RegimentRoom'
            },
            component: RegimentRoom
        },
        //团购列表
        {
            path: '/regimentRoomList',
            name: 'RegimentRoomList',
            meta: {
                parentMenu: 'OrderList'
            },
            component: RegimentRoomList
        },
        //民宿首页
        {
            path: '/homeStay',
            name: 'HomeStay',
            meta: {
                parentMenu: 'HomeStay'
            },
            component: HomeStay
        },
        //实时精选
        {
            path: '/realTimeSelectionList',
            name: 'RealTimeSelectionList',
            component: RealTimeSelectionList,
        },
        //账单查询
        {
            path: '/billList',
            name: 'BillList',
            meta: {
                parentMenu: 'OrderList'
            },
            component: BillList
        },
        //账单详情
        {
            path: '/billDetails/:id',
            name: 'BillDetails',
            component: BillDetails,
            meta: {
                isHome: true
            }
        },
        //子账号管理
        {
            path: '/subAccount',
            name: 'SubAccount',
            meta: {
                parentMenu: 'OrderList'
            },
            component: SubAccount
        },
        //基础信息
        {
            path: '/baseInfo',
            name: 'BaseInfo',
            meta: {
                parentMenu: 'OrderList'
            },
            component: BaseInfo
        },
        //信贷信息
        {
            path: '/receiptsBill',
            name: 'ReceiptsBill',
            meta: {
                parentMenu: 'OrderList'
            },
            component: ReceiptsBill
        },
        //信贷信息新
        {
            path: '/receiptsBillNew',
            name: 'ReceiptsBillNew',
            meta: {
                parentMenu: 'OrderList'
            },
            component: ReceiptsBillNew
        },
        //充值信息
        {
            path: '/chargeBill',
            name: 'ChargeBill',
            meta: {
                parentMenu: 'OrderList'
            },
            component: ChargeBill
        },
        //修改密码
        {
            path: '/resetPassword',
            name: 'ResetPassword',
            meta: {
                parentMenu: 'OrderList'
            },
            component: ResetPassword
        },
        //日看板
        {
            path: '/reportDay',
            name: 'ReportDay',
            meta: {
                parentMenu: 'OrderList'
            },
            component: ReportDay
        },
        //月看板
        {
            path: '/reportMonth',
            name: 'ReportMonth',
            meta: {
                parentMenu: 'OrderList'
            },
            component: ReportMonth
        },
        //交易报表
        {
            path: '/reportList',
            name: 'ReportList',
            component: ReportList,
            meta: {
                parentMenu: 'OrderList'
            },
        },
        //发票
        {
            path: '/invoice',
            name: 'Invoice',
            component: Invoice,
            meta: {
                parentMenu: 'OrderList'
            },
        },
        //发票信息
        {
            path: '/information',
            name: 'Information',
            component: Information,
            meta: {
                parentMenu: 'OrderList'
            },
        },
        //发票详情
        {
            path: '/invoiceDetails/:orderNO',
            name: 'InvoiceDetails',
            component: InvoiceDetails,
            meta: {
                parentMenu: 'OrderList'
            },
        },
        //酒店发票
        {
            path: '/hotel',
            name: 'Hotel',
            component: Hotel,
            meta: {
                parentMenu: 'OrderList'
            },
        },
        //门票
        {
            path: '/tickets',
            name: 'Tickets',
            meta: { 'parentMenu': 'Tickets' },
            component: Tickets
        },
        {
            path: '/ticketList',
            name: 'TicketList',
            meta: { 'parentMenu': 'Tickets' },
            component: TicketList
        },
        {
            path: '/ticketDetails',
            name: 'TicketDetails',
            meta: { 'parentMenu': 'Tickets' },
            component: TicketDetails
        },
        {
            path: '/ticketBook',
            name: 'TicketBook',
            meta: { 'parentMenu': 'Tickets' },
            component: TicketBook
        },
        {
            path: '/ticketBookComfirm',
            name: 'TicketBookComfirm',
            meta: { 'parentMenu': 'Tickets' },
            component: TicketBookComfirm
        },
        {
            path: '/ticketBookComplete',
            name: 'TicketBookComplete',
            meta: { 'parentMenu': 'Tickets' },
            component: TicketBookComplete
        },
        // 度假
        {
            path: '/packageList',
            name: 'PackageList',
            meta: {
                parentMenu: 'PackageList'
            },
            component: PackageList
        },
        {
            path: '/packageDetails',
            name: 'PackageDetails',
            meta: {
                parentMenu: 'PackageList'
            },
            component: PackageDetails
        },
        {
            path: '/packageBook',
            name: 'PackageBook',
            meta: {
                parentMenu: 'PackageList'
            },
            component: PackageBook
        },
        {
            path: '/packageBookComfirm',
            name: ' PackageBookComfirm',
            meta: {
                parentMenu: 'PackageList'
            },
            component: PackageBookComfirm
        },
        {
            path: '/packageBookComplete',
            name: ' PackageBookComplete',
            meta: {
                parentMenu: 'PackageList'
            },
            component: PackageBookComplete
        },
        {
            path: '/packageOrderList',
            name: ' PackageOrderList',
            meta: {
                parentMenu: 'OrderList'
            },
            component: PackageOrderList
        },
        // 订单详情
        {
            path: '/packageOrderDetails/:orderNO',
            name: 'PackageOrderDetails',
            component: PackageOrderDetails,
            meta: {
                isHome: true
            }
        },
        // 预约详情
        {
            path: '/packageReserve',
            name: 'PackageReserve',
            component: PackageReserve,
            meta: {
                isHome: true
            }
        },
        {
            path: '/reserveDetails',
            name: 'ReserveDetails',
            component: ReserveDetails,
            meta: {
                isHome: true
            }
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js